import React from 'react'
import LogoutFromTnAccountContainer from "../../auth/LogoutFromTnAccount";
import ENV from '../../env'
import forward from './img/forward-arrow.png'
import PropTypes from 'prop-types'

const ListItem = props => {
  const working = (parseInt(window.working) !== 0)
  let url;

  if (!!props.listItem.url) {
    url = ENV.root_path + new URL(props.listItem.url).pathname
  }

  if (working) {
    url = ENV.root_path + "/studio/page/" + props.listItem.id
  }



  if (props.listItem.title === 'Izloguj se' || props.listItem.title === 'Log out') {
    return <LogoutFromTnAccountContainer from={window.location.href}>
            <span id={props.listItem.id}
                  className={`no-child list-item ${props.level} ${props.listItem.cssClass} ${props.activeItem && props.level !== 'third-level' ? 'active' : ''}`}>
            {props.listItem.title}
            </span>
    </LogoutFromTnAccountContainer>;
  }

  if (props.listItem.img && props.listItem.img.length > 0) {
    return (
      <a href={`${props.listItem.redirectTo !== '' ? props.listItem.redirectTo : url}`} target="_blank"
        rel="noopener noreferrer" className='mx-2 d-flex align-items-center'>
        <img width="28" height="28" alt={props.listItem.img} className="d-block ml-4" src={require(`./img/${props.listItem.img}.png`)} />
        <span id={props.listItem.id}
        className={` ml-2 no-child list-item ${props.level} ${props.listItem.cssClass} ${props.activeItem && props.level !== 'third-level' ? 'active' : ''}`}>
          {props.listItem.title}
        </span>
        <img id={props.listItem.id} src={forward} alt="forward" className='mr-4 ytl-menu-item-arrow'/>
      </a>
    );
  }

  return (
    ((props.level !== 'second-level' && props.level !== 'mobile-second-level') || ((props.level === 'second-level' || props.level === 'mobile-second-level') && (props.listItem.items === undefined || props.listItem.items.length === 0))) ?
      <React.Fragment>
        {working ?
          <a href={`${props.listItem.redirectTo !== '' ? props.listItem.redirectTo : url}`} target="_blank"
             rel="noopener noreferrer">
                      <span id={props.listItem.id}
                            className={`no-child list-item ${props.level} ${props.listItem.cssClass} ${props.activeItem && props.level !== 'third-level' ? 'active' : ''}`}>
                          {props.listItem.title}
                      </span>
          </a> :
          <a href={`${props.listItem.redirectTo !== '' ? props.listItem.redirectTo : url}`}>
                      <span id={props.listItem.id}
                            className={`no-child list-item ${props.level} ${props.listItem.cssClass} ${props.activeItem && props.level !== 'third-level' ? 'active' : ''}`}>
                          {props.listItem.title}
                      </span>
          </a>
        }
      </React.Fragment> :
      <span id={props.listItem.id}
            className={`list-item ${props.level} ${props.listItem.cssClass} ${props.activeItem ? 'active' : ''}`}
            onClick={props.handleItemClick}>
        {props.listItem.title}
        {props.level === 'mobile-second-level' && props.listItem.items !== undefined && props.listItem.items.length > 0 &&
        <img id={props.listItem.id} src={forward} alt="forward"/>}
      </span>

  )
}

ListItem.propTypes = {
  activeItem: PropTypes.bool.isRequired,
  level: PropTypes.string.isRequired,
  listItem: PropTypes.object.isRequired,
}

export default ListItem


